import React, { useContext, useState, createContext, useEffect } from 'react';

export const ProductSelectContext = createContext(null);

export const ProductSelectProvider = ({ children }) => {
    const [productSelected, setProductSelected] = useState(null);
    useEffect(() => {
        console.log('productSelected', productSelected);
    }, [productSelected]);

    return (
        <ProductSelectContext.Provider
            value={{ productSelected, setProductSelected }}>
            {children}
        </ProductSelectContext.Provider>
    );
}
